import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { GoogleLoginCard } from "./card";
import { GoogleLoginModal } from "./modal";

const mapStateToProps = (_state: RootState) => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ saveIntegration }, dispatch);

interface Props extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
	integration: Integration;
}

interface State {
	modalOpen: boolean;
	name?: string;
	oauthId?: string;
	clientId?: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
			name: props.integration.name,
			oauthId: props.integration.data.googleLoginOAuthId as string,
			clientId: props.integration.data.googleLoginClientId as string,
		};
	}

	public handleSave = () => {
		const { integration, saveIntegration } = this.props;
		const { name, oauthId, clientId } = this.state;
		saveIntegration({ integration: {
			...integration, name,
			data: { ...integration.data, googleLoginOAuthId: oauthId, googleLoginClientId: clientId },
		}});
	};

	public render() {
		const { integration } = this.props;
		const { modalOpen, name, oauthId, clientId } = this.state;

		return (
			<>
				<GoogleLoginCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<GoogleLoginModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					name={name}
					oauthId={oauthId}
					clientId={clientId}
					onNameChange={name => this.setState({ name })}
					onOauthIdChange={oauthId => this.setState({ oauthId })}
					onClientIdChange={clientId => this.setState({ clientId })}
					onSave={this.handleSave}
				/>
			</>
		);
	}

}

export const GoogleLoginIntegration = connect(mapStateToProps, mapDispatchToProps)(Component);
